import React from 'react';

const TwitterIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M7.55 21.75c9.055 0 14.008-7.503 14.008-14.008 0-.21-.004-.426-.014-.637A9.999 9.999 0 0024 4.555c-.898.4-1.85.66-2.826.774a4.95 4.95 0 002.165-2.723 9.897 9.897 0 01-3.126 1.195 4.93 4.93 0 00-8.394 4.49A13.985 13.985 0 011.673 3.15a4.93 4.93 0 001.523 6.57 4.93 4.93 0 01-2.23-.614v.061a4.922 4.922 0 003.95 4.828 4.894 4.894 0 01-2.221.085A4.934 4.934 0 007.292 17.5 9.875 9.875 0 010 19.54a13.969 13.969 0 007.55 2.211z" />
  </svg>
);

export default TwitterIcon;
